export const getCookie = (cookies, name) => {
  const reducedCookies = cookies?.split(/[,;]/).reduce((accum, cookie) => {
    const [key, value] = cookie.split('=');
    if (key.trim() === name) {
      return value;
    }
    return accum;
  }, '');
  return reducedCookies?.length ? reducedCookies : '';
};